import { render } from "./HolidayDetails.vue?vue&type=template&id=73eb0251&scoped=true&ts=true"
import script from "./HolidayDetails.vue?vue&type=script&lang=ts"
export * from "./HolidayDetails.vue?vue&type=script&lang=ts"

import "./HolidayDetails.vue?vue&type=style&index=0&id=73eb0251&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73eb0251"]])

export default __exports__